import { render, staticRenderFns } from "./AddTalk.vue?vue&type=template&id=47038e43&scoped=true"
import script from "./AddTalk.vue?vue&type=script&lang=js"
export * from "./AddTalk.vue?vue&type=script&lang=js"
import style0 from "./AddTalk.vue?vue&type=style&index=0&id=47038e43&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47038e43",
  null
  
)

export default component.exports